import React from 'react';
import { connect } from 'react-redux';

import { goTo } from '../tools';

const mapState = (state) => {
    return {};
}
const mapDispatch = (dispatch) => {
    return {
        resetPaso: () => {
            dispatch({ "type": "OLVIDE_RESET_PASO" });
        }
    }
}

class UsuarioBloqueado extends React.Component {
	back = () => {
		this.props.resetPaso();
		goTo("login");
		//window.location.href = '/#!/login';
	}
	render() {
		return <div className="login-box">
			<div className="login-form">
				<h3>Usuario bloqueado</h3>
				<div className="text-center mt-34">
					<img src={require("../img/vector-cuenta-bloqueada.png")} alt="" />
					<div className="mt-25 texto-17">
						<p>Su cuenta esta inactiva o bloqueada.</p>
						<p>Favor de comunicarse al 55 5227 9000, opción 5 para recibir asistencia.</p>
					</div>
				</div>
			</div>
			<div className="text-center aceptar-cancelar-btn">
				<a onClick={this.back} className="orange-text">Aceptar</a>
			</div>
		</div>
	}
}

export default connect(mapState, mapDispatch)(UsuarioBloqueado);


// WEBPACK FOOTER //
// ./src/olvide/usuarioBloqueado.cmpt.js